require('./mixins/blockMutatorBaseMixin.js');
require('./mixins/copyable_view.js');

PegasusTemplate.BlockView = Em.ContainerView.extend(PegasusTemplate.BlockMutatorBaseMixin, PegasusTemplate.CopyableView, Ember.Copyable, {
  childViews: ['payloadView'],

  isHidden: function(){
    return '';
  },

  dataIsDisplayedBinding: 'payload.dataIsDisplayed',

  click: function(e){
    e.stopPropagation();
    e.preventDefault();
    if( this.get('isEdited') ){
      this.get('controller').send('touchedBlock');
      return false;
    }
    if( this.get('payload.context.isSaving') ){ return false; }

    PegasusTemplate.stateMachine.send('edit', this);
  },

  only: ['edit', 'delete'],

  isUserVisible: function(){
    return this.get('payload.dataIsDisplayed') === 'true';
  }.property('payload.dataIsDisplayed'),

  classNames: ['vr-content-block'],

  classNameBindings: [
    'isEdited:editing',
    'isUserVisible::user-hidden'
  ],

  payloadView: Ember.required,

  mouseMove: function(){
    if ( ! this.get('isEdited') ) {
      this.mouseEnter();
      return false;
    }
  },

  column: null,

  didInsertElement: function(){
    this._super();

    if( this.get('parentView') && this.get('parentView').indexOf ){
      this.set('lastCell', this.get('parentView') );
      this.set('lastIndex', this.get('parentView').indexOf( this ) );
    }
  },

  willDestroyElement: function(){
    Em.run.scheduleOnce('afterRender', this.get('parentView'), 'didDeleteBlock', this);
    this._super();
  },

  lastIndex: null,

  mouseEnter: function(e) {
    this._super();
    PegasusTemplate.stateMachine.send('hover', {view: this });
    return;
  },

  isVisible: true,

  isEdited: function(){
    var editingContent = this.get('controller.controllers.editing.content'),
      fragment = this.get('payload');

    return editingContent === fragment;
  }.property('controller.controllers.editing.content', 'payload')
});
